import { FC } from 'react'
import { AtSign } from 'lucide-react'

type CmpProps = {
  isUsersList?: boolean
}

const EmptyList: FC<CmpProps> = ({ isUsersList }) => {
  if (!isUsersList) {
    return <div>Nothing found</div>
  }

  return (
    <div className="gap-xxs py-xxs mt-xxs flex items-center">
      <div className="size-m flex items-center justify-center rounded-full bg-gray-100">
        <AtSign size={20} className="text-gray-500" />
      </div>
      <div className="text-base">
        <h3 className="font-medium text-gray-900">No user found</h3>
        <p className="text-gray-500">
          Enter an email to invite a friend outside the platform
        </p>
      </div>
    </div>
  )
}

export default EmptyList
